import type { ReactElement } from "react";
import { Datagrid, ReferenceField, TextField, useListContext } from "react-admin";
import { useMediaQuery } from "@mui/material";
import type { Theme } from "@mui/material";
import { useNavigate } from "react-router";
import { grants } from "../../backoffice.access_control";
import { Column } from "../../misc/Column";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import type { DrivingSchool } from "../../providers/drivingSchoolsProvider";
import type { Room } from "../../providers/roomsProvider";
import { RoomMobileListItem } from "./RoomMobileListItem";

export function RoomsDataGrid(props: { drivingSchool: DrivingSchool; empty?: ReactElement }) {
  const { drivingSchool, empty } = props;
  const { isLoading, data, total } = useListContext<Room>();
  const navigate = useNavigate();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
  const rowClick = grants.has("Room:edit") ? "edit" : false;

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (isMobile) {
    if (!data || data.length === 0 || total === 0) {
      return empty ?? null;
    }

    return (
      <Column sx={{ gap: 1, py: "1px" }}>
        {data.map((room) => (
          <RoomMobileListItem
            key={room.id}
            room={room}
            branchName={drivingSchool.branchesById[room.branchId]?.name}
            onClick={rowClick === false ? undefined : () => navigate(`/rooms/${room.id}`)}
          />
        ))}
      </Column>
    );
  }

  return (
    <Datagrid rowClick={rowClick} bulkActionButtons={false} empty={empty}>
      <TextField label="Raum" source="name" />
      <TextField label="Beschreibung" source="description" />
      <TextField label="Anzahl Sitzplätze" source="numberOfSeats" />
      <ReferenceField label="Filiale" source="branchId" reference="branches" />
    </Datagrid>
  );
}
